<template>
  <!-- 添加项目 -->
  <div class="right_container" style="width:1000px;">
    <div class="create_audit" :style="'height:'+bar_height+'px;'">
      <div class="template_title">新建审批</div>
    </div>
    <!--{{project_data}}-->
    <div
      class="scroll_div"
      :style="'height:'+ (height - bar_height - btn_height-10) +'px;overflow:auto'"
    >
      <div v-for="(item,index) in templates" :key="index+''">
        <v-input
          v-if="item.type=='input'"
          :moduel="item"
          :projectData="approval_data"
          v-model="approval_data[item.key_name]"
          v-on:listenToChildEvent="checkParams"
          :input_callback="set_add_project_input"
          type="audit"
        ></v-input>
        <v-select
          v-if="item.type=='select'"
          :moduel="item"
          :projectData.sync="approval_data"
          v-model="approval_data[item.key_name]"
          v-on:listenToChildEvent="checkParams"
          type="audit"
        ></v-select>
        <v-select_flow
          v-if="item.type=='select_flow'"
          :moduel.sync="item"
          :projectData.sync="approval_data"
          v-model="approval_data[item.key_name]"
          v-on:listenToChildEvent="checkParams"
          type="audit"
        ></v-select_flow>
        <v-select_flow
          v-if="item.type=='select_project_user'"
          :moduel.sync="item"
          :projectData.sync="approval_data"
          v-model="approval_data[item.key_name]"
          v-on:listenToChildEvent="checkParams"
          type="audit"
        ></v-select_flow>
        <v-text
          v-if="item.type=='text'"
          :moduel="item"
          :projectData.sync="approval_data"
          v-model="approval_data[item.key_name]"
          v-on:listenToChildEvent="checkParams"
          type="audit"
        ></v-text>
        <div v-if="item.key_name=='document_ids'" style="vertical-align: top">
          <v-filelist_multiple
            :moduel="item"
            :projectData.sync="approval_data"
            v-model="approval_data[item.key_name]"
            :input_callback="set_filelist"
            ref="approvalfiles"
            type="audit"
          ></v-filelist_multiple>
        </div>
      </div>
    </div>
    <div :style="'text-align: center;height:'+ btn_height +'px;'">
      <span
        class="category_btn create_btn canceal"
        @click="close_add_wrapper"
        style="margin: 0 50px;"
      >取消</span>
      <span
        class="category_btn create_btn"
        :class="{'typeSelected':add_project_sunbmit}"
        @click="create_audit"
        v-if="add_project_sunbmit"
      >创建</span>
      <span class="category_btn create_btn" v-else>创建</span>
      <div style="color: red;">{{project_tips}}</div>
    </div>
  </div>
</template>

<style scoped>
/* .right_container {
  /* padding-left: 30px; */
/* } */
.create_audit {
  border-bottom: 1px solid #cbcbcb;
  line-height: 40px;
}
.create_btn {
  width: 80px;
  text-align: center;
}
.create_btn.canceal {
  background: #fff !important;
  border: 1px solid #ccc;
}
</style>

<script>
export default {
  name: "",
  data() {
    return {
      bar_height: 40,
      btn_height: 54,
      project_tips: "",
      timer: "",
      customer_ids: [],
      user_list: [],
      project_user_list: [],
      content: "",
      name: "",
      createTime: "",
      add_project_sunbmit: false,
      // show_ellipsis:false,
      description_high: 0,
      function_type1: "",
      documentsList: [],
      tips_approval: "",
      approval_data: {},
      header: 60,
      pagination_height: 30,
      pageSize: 10,
      dialogAdd_approval: false,
      upload_file_data: {},
      templates: [],
      limit: 1,
      files: []
    };
  },
  props: [
    "height",
    "width",
    "web_token",
    "user_info",
    "web_url",
    "get_approval"
  ],
  // store,
  methods: {
    backToLogin() {
      this.$router.push("/login");
    },
    set_add_project_input() {},
    set_filelist(_content) {
      this.approval_data.document_ids = _content;
    },
    // 关闭新建
    close_add_wrapper() {
      var that = this;
      this.$confirm(
        "正在新建审批，离开会丢失录入的内容，是否确定离开？",
        "提示",
        {
          cancelButtonText: "继续编辑",
          confirmButtonText: "确定离开",
          type: "warning"
        }
      )
        .then(() => {
          this.$router.push({ path: "/main/auditing/welcome" });
        })
        .catch(() => {});
    },
    checkParams() {
      for (var i = 0; i < this.templates.length; i++) {
        if (this.templates[i].required) {
          if (
            this.approval_data[this.templates[i].key_name] == "" ||
            this.approval_data[this.templates[i].key_name] == []
          ) {
            console.log(this.add_project_sunbmit);
            this.add_project_sunbmit = false;
            return false;
          }
        }
      }
      this.add_project_sunbmit = true;
    },
    //重置参数 添加项目
    resetparem_approval() {
      var typeArray = [
        "select_flow",
        "select_project_user",
        "select_upload_file",
        "select_project_user"
      ];
      for (var i = 0; i < this.templates.length; i++) {
        if (typeArray.indexOf(this.templates[i].type) > -1) {
          console.log(this.templates[i].key_name);
          this.approval_data[this.templates[i].key_name] = [];
        } else {
          this.approval_data[this.templates[i].key_name] = "";
        }
      }
    },
    //获取审批模板
    getTemplate: function() {
      this.$http
        .post(
          this.web_url + "/project/vue_template",
          { web_token: this.web_token, system: "web", model_id: 7 },
          { emulateJSON: true }
        )
        .then(function(res) {
          // console.log(this.templates);
          if (res.data.status == "ok") {
            this.templates = res.data.data;
            this.resetparem_approval();
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //添加项目
    create_audit() {
      this.approval_data.web_token = this.web_token;
      this.$http
        .post(this.web_url + "/approval/apply", this.approval_data, {
          emulateJSON: true
        })
        .then(function(res) {
          if (res.data.status == "ok") {
            this.get_approval();
            this.$router.push({ path: "/main/auditing/welcome" });
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          } else {
            var _this = this;
            clearInterval(this.timer);
            this.project_tips = res.data.message;
            this.timer = setInterval(function() {
              _this.project_tips = "";
            }, 2000);
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    }
  },
  computed: {},
  mounted() {
    this.getTemplate();
  },
  created() {},
  watch: {},
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/page/auditing/create_auditing.vue